import type { FC } from 'react';
import { Trace, TraceLine, TraceTitle } from './trace';

interface ChatThinkingProps {
  /** What the Assistant is doing, e.g. "Reading courier health". */
  label?: string;
}

/**
 * Placeholder for the gap between sending and the first streamed token: a
 * shimmering trace line, announced politely to screen readers.
 */
export const ChatThinking: FC<ChatThinkingProps> = ({ label = 'Thinking…' }) => (
  <Trace role="status" aria-live="polite">
    <TraceLine status="running">
      <TraceTitle>{label}</TraceTitle>
    </TraceLine>
  </Trace>
);
